import { firebaseAuth } from "../../../firebase";
import { signOut } from "firebase/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../stateDefs";

export default function SignOut() {
  const setUser = useUser((state) => state.setUser);
  const navigate = useNavigate();

  useEffect(() => {
    signOut(firebaseAuth);
    setUser(null);
    navigate("/");
  }, []);

  return <div>Signing out...</div>;
}
